import { React, useRef, useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import './Support.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation} from 'swiper/modules';
import { TbWorld } from "react-icons/tb";
import { GrSecure } from "react-icons/gr";
import { MdPeopleAlt, MdSchool, MdHealthAndSafety  } from "react-icons/md";
import { FaHandsHelping } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../../Firebase_Config/firebase';








const Support = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);

  {/*const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    },
  };*/}

  const handleButtonClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  const navButtons = [
    { label: 'Sign Up', slideIndex: 0 },
    { label: 'Conformity Analysis', slideIndex: 1 },
    { label: 'Threat Analysis', slideIndex: 4 },
    { label: 'AI Policy Pro', slideIndex: 8 },
    { label: 'Dashboard', slideIndex: 11 },
    { label: 'Threat Intelligence', slideIndex: 12 },
    { label: 'AI Risk Database', slideIndex: 14 },
    { label: 'Data Profiler', slideIndex: 15 },
    { label: 'Data Security', slideIndex: 16 },
    { label: 'SecAI', slideIndex: 17 },
    { label: 'Model Evaluation', slideIndex: 19 },
    { label: 'Privacy Meter', slideIndex: 20 },
    { label: 'Federated Learning', slideIndex: 21 },
    { label: 'Homomorphic Encryption', slideIndex: 22 },
    { label: 'ATLAS', slideIndex: 24 },
  ];
//MdSchool
  return (
    <div className='supportBG'>
      <div className='HelpMainContent'>
        <div className='bannerBG'>
          <img src="banner.png" alt="banner" className='banner-image' />
        </div>
        
        <h1 className='helptitle bigger'>Support Centre</h1>
        <div className='supportGrid'>
          <NavLink to="/Support/GeneralAI" >
            <button className="navButtons">
              <div>
                <TbWorld className="helpicons" />
              </div>
              <span>General AI Training</span>
            </button>
          </NavLink>
          <NavLink to="/Support/DataEthics">
            <button className="navButtons">
              <div>
                <FaHandsHelping className="helpicons" />
              </div>
              <span>Data Ethics</span>
            </button>
          </NavLink>
          <NavLink to="/Support/ResponsibleAI">
            <button className="navButtons">
              <div>
                <MdPeopleAlt className="helpicons" />
              </div>
              <span>Responsible AI</span>
            </button>
          </NavLink>
          <NavLink to="/Support/AiSafety">
            <button className="navButtons">
              
              <div>
                <MdHealthAndSafety   className="helpicons" />
              </div>
              <span>AI Safety</span>
            </button>
          </NavLink>
          <NavLink to="/Support/SecurityAndPrivacy">
            <button className="navButtons">
              <div>
                <GrSecure className="helpicons" />
              </div>
              <span>Security and Privacy in AI</span>
            </button>
          </NavLink>
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        <div className='supportL2'>
          <h1 className='helptitle'>Further Support</h1>
          <div className="button-grid">
            {navButtons.map((btn, i) => (
              <button
                key={i}
                onClick={() => handleButtonClick(btn.slideIndex)}
              >
                {btn.label}
              </button>
            ))}
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              type: 'fraction',
            }}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="mySwiper"
            observer={true}
            observeParents={true}
            lazy={true}
            onSwiper={setSwiperInstance}
          >
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='support-card-accent'/>
                    <h1 className='help-card-title'>Sign Up</h1>
                    <img src="/HelpImages/Slide1.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here on the Sign-Up page the user must complete <b>ALL</b> the fields and use a secure password.</p>
                  </div>
                  <br/>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Conformity Analysis</h1>
                    <img src="/HelpImages/Slide2.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here the Conformity Analysisis split into categories as shown above and progress towards compliance for each one can be tracked as shown by the % on the right hand side. <b>Next Slide for Conformity Analysis Cont.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Conformity Analysis Cont.</h1>
                    <img src="/HelpImages/Slide3.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                     <p> Within each category click on the small <b>ARROW</b> on the left hand side to see the sub categories and clauses. The <b>THREE DOTS</b> on the right hand side will open up a box where the user can enter their progress. <b>Next Slide for Conformity Analysis Cont2.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                 
                  <div className='HelpContainer'>
                    <div className='card-accent'/>                   
                    <h1 className='help-card-title'>Conformity Analysis Cont2.</h1>
                    <img src="/HelpImages/Slide4.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p> Here the user will enter their progress in the pop up box entering a score 1-100 but also uploading supporting evidence and relevent remarks. The user must do this for <b>ALL</b> clauses in <b>ALL</b> categories. Once done the user will be redirected to the Threat Analysis.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Threat Analysis</h1>
                    <img src="/HelpImages/Slide5.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p> Here the Threat Analysis is once again split into categories as shown above. <b>Next Slide for Threat Analysis Cont.</b>  </p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Threat Analysis Cont.</h1>
                    <img src="/HelpImages/Slide6.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p> Within each category click on the small <b>ARROW</b> on the left hand side to see the sub categories and clauses. The user must pick <b>YES</b> and <b>NO</b> buttons on the right hand side.<b>Next Slide for Threat Analysis Cont2.</b> </p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                 
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Threat Analysis Cont2.</h1>
                    <img src="/HelpImages/Slide7.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>If the user picks <b>YES</b>. The User will be prompted to upload evidence which will then be approved by their admin <b>Next Slide for Threat Analysis Cont3.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">  
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Threat Analysis Cont3.</h1>
                    <img src="/HelpImages/Slide8.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p> If the user picks <b>NO</b>. The co-pilot will activate and will prompt the user on how the implement the current statement.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>                   
                    <h1 className='help-card-title'>AI Policy Pro</h1>
                    <img src="/HelpImages/Slide24.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>AI Policy Pro is a place where user can generate help for making compliance documents.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide><SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>                   
                    <h1 className='help-card-title'>AI Policy Pro Cont.</h1>
                    <img src="/HelpImages/Slide25.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>The users selects one of the dropdowns and enters all the relevent information.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide><SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>                   
                    <h1 className='help-card-title'>AI Policy Pro Cont2.</h1>
                    <img src="/HelpImages/Slide26.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>A document is then generated. This is not supposed to replace but rather support your compliance document making.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>                   
                    <h1 className='help-card-title'>Dashboard</h1>
                    <img src="/HelpImages/Slide9.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>The <b>Dashboard</b> appears after the <b>Conformity Analysis</b> and <b>Threat Analysis</b> are complete. Here you can find metrics corressponding to your repsonses.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">               
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Threat Intelligence</h1>
                    <img src="/HelpImages/Slide10.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Initial Threat Intelligence is available by selecting one of the <b>Categories</b>. <b>Next Slide for Threat Intelligence Cont.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Threat Intelligence Cont.</h1>
                    <img src="/HelpImages/Slide11.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Then using the dropdown menus to learn about the threats.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                  
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>AI Risk Database</h1>
                    <img src="/HelpImages/Slide12.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the AI Risk Database. Browse each category to see a range of AI Risk.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                  
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Data Profiler</h1>
                    <img src="/HelpImages/Slide13.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the RapidProfile Tool and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page to contact us.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                  
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Data Security</h1>
                    <img src="/HelpImages/Slide14.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the Data Security tool and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page to contact us.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                  
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>SecAI</h1>
                    <img src="/HelpImages/Slide15.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is SecAI and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page. <b>Next Slide for SecAI Cont.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>SecAI Cont.</h1>
                    <img src="/HelpImages/Slide16.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is SecAI whiched will be launched in a separate tab – the screen above appears – enter and ip address or a domain name to further access real-time AI driven threat intelligence specific to that infrastructure.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Model Evaluation</h1>
                    <img src="/HelpImages/Slide17.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the Model Evaluation Tool and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page to contact us.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
             <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Privacy Meter</h1>
                    <img src="/HelpImages/Slide18.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the Privacy Meter Tool and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page to contact us.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>           
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">                
                  <div className='HelpContainer'>
                    <div className='card-accent'/> 
                    <h1 className='help-card-title'>Federated Learning</h1>
                    <img src="/HelpImages/Slide20.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the Federated Learning Tool and supporting information explaining what the tool is.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Homomorphic Encryption</h1>
                    <img src="/HelpImages/Slide21.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is the Homomorphic Encryption Tool and supporting information explaining what the tool is. To access the tool click the purple button at the bottom of the page..<b>Next Slide for Homomorphic Encryption Cont.</b></p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>Homomorphic Encryption Cont.</h1>
                    <img src="/HelpImages/Slide22.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is a demonstration of the Homomorphic Encryption tool.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>ATLAS</h1>
                    <img src="/HelpImages/Slide27.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is ATLAS and supporting information. To Access ATLAS click the button at the bottom of the page.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div class="help-card ">
                <div class="help-card-content">
                  <div className='HelpContainer'>
                    <div className='card-accent'/>
                    <h1 className='help-card-title'>ATLAS Cont.</h1>
                    <img src="/HelpImages/Slide28.PNG" alt="Slide" className='Help-image' />
                  </div>
                  <div className='HelpContainer text'>
                    <p>Here is a look at what ATLAS looks like.</p>
                  </div>
                  <br/>        
                </div>
              </div>
            </SwiperSlide>

          </Swiper>
          <br/>
        </div>
      </div>
    </div>
  );
};

export default Support;
